export default __webpack_public_path__ + "static/media/Karimnagar-Diocese.8cea7c1f.png";